module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [(_vm.$route.params.serviceCode) ? _c('b-button', {
    attrs: {
      "to": {
        name: 'app-list',
        params: {
          serviceCode: _vm.$route.params.serviceCode
        }
      },
      "size": "sm",
      "variant": "link"
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  })]) : _vm._e(), _vm._v("\n    统计数据\n  ")], 1), _vm._v(" "), (_vm.checkAdminType()) ? _c('b-link', {
    attrs: {
      "to": {
        name: 'tag-list'
      }
    }
  }, [_c('b-button', {
    style: ({
      marginBottom: '18px'
    }),
    attrs: {
      "variant": "outline-primary"
    }
  }, [_vm._v("\n      标签管理\n    ")])], 1) : _vm._e(), _vm._v(" "), _c('b-card', [_c('b-form', [_c('b-form-group', {
    attrs: {
      "label": "服务：",
      "label-for": "name"
    }
  }, [_c('el-select', {
    staticClass: "mb-2",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "id": "service_code"
    },
    model: {
      value: (_vm.query.service_code),
      callback: function($$v) {
        _vm.$set(_vm.query, "service_code", $$v)
      },
      expression: "query.service_code"
    }
  }, _vm._l((_vm.services), function(service) {
    return _c('el-option', {
      key: service.value,
      attrs: {
        "label": service.text,
        "value": service.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label-for": "product_code",
      "label": "产品："
    }
  }, [_c('el-select', {
    staticClass: "mb-2",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "filterable": "",
      "id": "product_code"
    },
    model: {
      value: (_vm.query.product_code),
      callback: function($$v) {
        _vm.$set(_vm.query, "product_code", $$v)
      },
      expression: "query.product_code"
    }
  }, _vm._l((_vm.products), function(product) {
    return _c('el-option', {
      key: product.value,
      attrs: {
        "label": product.text,
        "value": product.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label-for": "app_code",
      "label": "实例："
    }
  }, [_c('el-select', {
    staticClass: "mb-2",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "id": "app_code"
    },
    model: {
      value: (_vm.query.app_code),
      callback: function($$v) {
        _vm.$set(_vm.query, "app_code", $$v)
      },
      expression: "query.app_code"
    }
  }, _vm._l((_vm.apps), function(app) {
    return _c('el-option', {
      key: app.value,
      attrs: {
        "label": app.text,
        "value": app.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label-for": "tag",
      "label": "标签："
    }
  }, [_c('b-form-checkbox-group', {
    attrs: {
      "name": "tag",
      "options": _vm.tagList
    },
    model: {
      value: (_vm.query.tags),
      callback: function($$v) {
        _vm.$set(_vm.query, "tags", $$v)
      },
      expression: "query.tags"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label-for": "start_time",
      "label": "时间范围:"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "start-placeholder": "开始时间",
      "end-placeholder": "结束时间",
      "format": "yyyy-MM-dd HH:mm:ss",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "picker-options": _vm.dateOptions
    },
    model: {
      value: (_vm.query.query_time),
      callback: function($$v) {
        _vm.$set(_vm.query, "query_time", $$v)
      },
      expression: "query.query_time"
    }
  })], 1), _vm._v(" "), _c('a', {
    ref: "download",
    staticClass: "hidden",
    attrs: {
      "href": "#"
    }
  }), _vm._v(" "), _c('b-button', {
    style: ({
      marginBottom: '18px'
    }),
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": function($event) {
        return _vm.queryStat('query')
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('b-button', {
    style: ({
      marginBottom: '18px'
    }),
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": function($event) {
        return _vm.queryStat('download')
      }
    }
  }, [_vm._v("下载")])], 1)], 1), _vm._v(" "), _vm._l((_vm.items), function(stats, tag) {
    return _c('b-card', {
      key: tag,
      attrs: {
        "no-body": "",
        "header": _vm.tagName(tag)
      }
    }, [_c('stat-chart', {
      attrs: {
        "data": stats,
        "fields": _vm.fields
      }
    }), _vm._v(" "), _c('b-table', {
      attrs: {
        "responsive": "sm",
        "items": stats,
        "fields": _vm.tableFields
      }
    })], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-14c8402f!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/stat/Stat.vue
// module id = HuyK
// module chunks = 4